<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Transaction Activity Type</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Transaction Activity Type</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="EWTrxActivityType">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWTrxActivityTypeList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">


                  <div class="form-group required">
                    <label class="control-label">Activity Type</label>
                    <input type="text" id="activity_type" name="activity_type"
                           v-bind:class="{'has-error' : errors.has('activity_type')}"
                           v-validate="'required'"
                           v-model="value.activity_type" class="form-control activity_type"
                           placeholder="Activity Type">
                    <div class="help text-danger" v-show="errors.has('activity_type')">
                      {{ errors.first("activity_type") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">Receiver Type</label>
                    <select class="form-control" style="width: 100%;" id="receiver_type_id"
                            name="receiver_type_id"
                            v-model="value.receiver_type_id"
                            placeholder="Receiver Type"
                    >
                      <option value="0">Select - Any</option>
                      <option v-for="(val) in activityTypes" :value="val.value">{{ val.label }}</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('receiver_type_id')">
                      {{ errors.first("receiver_type_id") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Slug</label>
                    <input type="text" id="slug" name="slug"
                           v-bind:class="{'has-error' : errors.has('slug')}"
                           v-validate="'required'"
                           v-model="value.slug" class="form-control slug"
                           placeholder="Slug">
                    <div class="help text-danger" v-show="errors.has('slug')">
                      {{ errors.first("slug") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Per Trx Min Amount</label>
                    <input type="text" id="per_trx_min_amount" name="per_trx_min_amount"
                           v-bind:class="{'has-error' : errors.has('per_trx_min_amount')}"
                           v-validate="'required'"
                           v-model="value.per_trx_min_amount" class="form-control per_trx_min_amount"
                           placeholder="Per Trx Min Amount">
                    <div class="help text-danger" v-show="errors.has('per_trx_min_amount')">
                      {{ errors.first("per_trx_min_amount") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Per Trx Max Amount</label>
                    <input type="text" id="per_trx_max_amount" name="per_trx_max_amount"
                           v-bind:class="{'has-error' : errors.has('per_trx_max_amount')}"
                           v-validate="'required'"
                           v-model="value.per_trx_max_amount" class="form-control per_trx_max_amount"
                           placeholder="Per Trx Max Amount">
                    <div class="help text-danger" v-show="errors.has('per_trx_max_amount')">
                      {{ errors.first("per_trx_max_amount") }}
                    </div>
                  </div>


                  <div class="form-group required">
                    <label class="control-label">Status</label>
                    <select class="form-control" style="width: 100%;"
                            v-bind:class="{'has-error' : errors.has('status')}"
                            v-validate="'required'" name="status" v-model="value.status" id="status">
                      <option value="active">active</option>
                      <option value="inactive">inactive</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWTrxActivityTypeForm',
  metaInfo: {
    title: 'EW Trx Activity Type | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    activityTypes: [],
    value: {},
    pre: {}
  }),
  methods: {


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_trx_activity_types'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_trx_activity_types/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWTrxActivityTypeList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_trx_activity_types_details/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })


      }

      this.is_loading = false
    },
    getActivityTypes: function () {
      this.is_loading = true
      axios.get("/get-trx-activity-types")
        .then(response => {
          // console.log('response', response)
          this.activityTypes = response.data
        })
        .catch((error) => {
          console.log('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
        });
    },
  },
  mounted() {
    this.initialize()
    this.getActivityTypes()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

